import {
    ConsentLinkAddPaymentCardRequest,
    IConsentActionPayload,
    IConsentDraftPayload,
} from "../types/consent-link.types";
import consentLinkClient, {
    clearConsentLinkToken,
    setConsentLinkToken,
} from "./consent-link.client";
import { persistConsentSession } from "./consent-link.session";

export async function exchangeConsentLinkToken(token: string) {
    clearConsentLinkToken();
    const response = await consentLinkClient.post("/consent-link/exchange", {
        token,
    });

    if (!response.data.scoped_token || !response.data.consent_id) {
        throw new Error("Invalid consent-link response");
    }

    setConsentLinkToken(response.data.scoped_token);
    persistConsentSession(response.data);
    return response.data;
}

export async function getScopedConsent() {
    const response = await consentLinkClient.get("/consent-link/consent");
    return response.data;
}

export async function saveScopedConsentDraft(data: IConsentDraftPayload) {
    const response = await consentLinkClient.patch(
        "/consent-link/consent/draft",
        data
    );
    return response.data;
}

export async function recordScopedConsentAction(data: IConsentActionPayload) {
    const response = await consentLinkClient.post(
        "/consent-link/consent/action",
        data
    );
    return response.data;
}

export async function getScopedPaymentCardStatus() {
    const response = await consentLinkClient.get(
        "/consent-link/payment-card/status"
    );
    return response.data;
}

export async function getScopedAuthorizeNetKeys() {
    const response = await consentLinkClient.get(
        "/consent-link/payment-card/authorize-net-keys"
    );
    return response.data;
}

export async function addScopedPaymentCard(
    data: ConsentLinkAddPaymentCardRequest
) {
    const response = await consentLinkClient.post(
        "/consent-link/payment-card",
        data
    );
    return response.data;
}

export async function downloadScopedConsentDocument(documentId: string) {
    const response = await consentLinkClient.get(
        `/consent-link/consent/document/${encodeURIComponent(documentId)}`
    );
    return response.data;
}

export async function uploadScopedConsentAttachments(
    fieldId: string,
    files: File[]
) {
    const formData = new FormData();
    formData.append("field_id", fieldId);
    files.forEach((file) => formData.append("document", file));
    const response = await consentLinkClient.post(
        "/consent-link/consent/attachment",
        formData
    );
    return response.data;
}
